export type VideoToolKind = 'upscale' | 'extend' | 'edit';
/**
 * The two tools with a marketing landing page + FAQ of their own
 * (VideoFinishingLanding). The editor is workspace-only for now.
 */
export type VideoFinishingToolKind = Exclude<VideoToolKind, 'edit'>;

export const VIDEO_TOOL_ROUTES = {
  upscale: {
    landing: '/ai-video-upscaler',
    workspace: '/ai-videos?tab=upscale-video',
  },
  extend: {
    landing: '/ai-video-extender',
    workspace: '/ai-videos?tab=extend-video',
  },
  edit: {
    landing: '/edit-video-with-ai',
    workspace: '/ai-videos?tab=edit-video',
  },
} as const;

/** Preserve gallery inputs and model choices when migrating older tab links. */
export function videoToolHref(
  kind: VideoToolKind,
  query: Record<string, string | string[] | undefined> = {},
): string {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(query)) {
    if (key === 'tab' || value === undefined) continue;
    for (const item of Array.isArray(value) ? value : [value])
      params.append(key, item);
  }
  const workspace = VIDEO_TOOL_ROUTES[kind].workspace;
  return workspace + (params.size ? `&${params}` : '');
}
